import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export function UpdateBanner() {
  const { t } = useTranslation()
  const [updateAvailable, setUpdateAvailable] = useState(false)

  useEffect(() => {
    function handleUpdate() {
      setUpdateAvailable(true)
    }

    window.addEventListener("sw-update-available", handleUpdate)
    return () => window.removeEventListener("sw-update-available", handleUpdate)
  }, [])

  if (!updateAvailable) return null

  function handleReload() {
    navigator.serviceWorker.ready.then((registration) => {
      registration.waiting?.postMessage({ type: "SKIP_WAITING" })
    })
  }

  return (
    <div className="update-banner">
      <span>{t("pwa.updateAvailable")}</span>
      <button className="primary-button" onClick={handleReload} type="button">
        {t("pwa.update")}
      </button>
    </div>
  )
}
